import Modal from "react-modal";
import { toast } from "react-toastify";
import "../../TimeTrackerTag/TimeTrackerTag.css";
import "../../../Clients/ClientsOverview.css";
import "./TimetrackerTeamDepartment.css";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { ReactComponent as Delete } from "../../../../images/icons/delete.svg";
import React, { useEffect, useState, useRef } from "react";
import { logout, reset } from "../../../../features/auth/authSlice.js";
import { ReactComponent as AddIcon } from "../../../../images/team-member-tab/add-icon.svg";
import { ReactComponent as CrssrImage } from "../../../../images/singleinvoice/cross-red.svg";
import { ReactComponent as EditImgBlue } from "../../../../images/team-member-tab/edit-btn-blue.svg";
import { reset as invoiceReset } from "../../../../features/invoice/invoiceSlice.js";
import { reset as headerReset } from "../../../../features/headerText/headerTextSlice.js";
import { reset as appSettingsReset } from "../../../../features/appSettings/appSettingsSlice.js";
import {
  useCreateUserDepartment,
  useDeleteUserDepartment,
  useFetchUserDepartments,
  useUpdateUserDepartment,
} from "./teamDepartmentApi.jsx";

const TimeTrackerTeamDepartment = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [selectedId, setSelectedId] = useState("");
  const [userDeptCreate, setUserDeptCreate] = useState("");
  const [deptCreateError, setDeptCreateError] = useState(false);
  const [shouldAnimate, setShouldAnimate] = useState(false);
  const userDeptCreateRef = useRef(null);
  const [userDeptEdit, setUserDeptEdit] = useState("");
  const [updatedDeptList, setUpdatedDeptList] = useState([]);
  const [filter, setFilter] = useState("");
  const [selectedSortOption, setSelectedSortOption] = useState(null);
  const [checkedOption, setCheckedOption] = useState(null);
  const [sortDropdownOpen, setSortDropdownOpen] = useState(false);
  const sortDropdownRef = useRef(null);
  const user = useSelector((state) => state.auth.user);
  let token = null;
  if (user) {
    if (user && user.token) {
      token = user.token;
    }
  }
  const {
    data: userDept = [],
    isLoading,
    isError,
  } = useFetchUserDepartments(token);

  const deleteUserDepartmentMutation = useDeleteUserDepartment(token);
  const createUserDepartmentMutation = useCreateUserDepartment(token);
  const updateUserDepartmentMutation = useUpdateUserDepartment(token);

  const selectSortOption = (option) => {
    setSelectedSortOption(option);
    setCheckedOption(option);
    setSortDropdownOpen(false);
  };

  const toggleSortDropdown = () => {
    setSortDropdownOpen(!sortDropdownOpen);
  };

  useEffect(() => {
    if (isLoading) setShouldAnimate(true);
  }, [isLoading]);

  const prevUserDeptRef = useRef(null);
  useEffect(() => {
    // Ensure userDept is an array
    const userDeptArray = Array.isArray(userDept) ? userDept : [];

    // Check if userDept has actually changed by comparing JSON strings
    const currentUserDeptString = JSON.stringify(userDeptArray);
    const dataChanged = prevUserDeptRef.current !== currentUserDeptString;

    // Only update if data has actually changed or this is the first render
    if (dataChanged || prevUserDeptRef.current === null) {
      prevUserDeptRef.current = currentUserDeptString;
      setUpdatedDeptList(userDeptArray);
    }
  }, [userDept]);
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        document.activeElement.blur();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const sortData = (data, sortOption) => {
    if (!Array.isArray(data)) return [];
    switch (sortOption) {
      case "By name: A - Z":
        return data
          .slice()
          .sort((a, b) =>
            (a?.user_department || "").localeCompare(b?.user_department || "")
          );
      case "By name: Z - A":
        return data
          .slice()
          .sort((a, b) =>
            (b?.user_department || "").localeCompare(a?.user_department || "")
          );
      case "Date: old to new":
        return data
          .slice()
          .sort(
            (a, b) =>
              new Date(a?.created_at || 0) - new Date(b?.created_at || 0)
          );
      case "Date: new to old":
        return data
          .slice()
          .sort(
            (a, b) =>
              new Date(b?.created_at || 0) - new Date(a?.created_at || 0)
          );
      default:
        return data;
    }
  };

  const sortedData = sortData(updatedDeptList, selectedSortOption);

  const seen = new Set();
  const filteredData = sortedData.filter((item) => {
    if (!item?.user_department) return false;
    const name = item.user_department.toLowerCase();
    if (seen.has(name)) return false;
    seen.add(name);
    return name.includes(filter.toLowerCase());
  });

  const handleClickOutsideDropdown = (event) => {
    const isClickInsideSortDropdown =
      sortDropdownRef.current &&
      sortDropdownRef.current.contains(event.target);

    if (!isClickInsideSortDropdown) {
      setSortDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutsideDropdown);
    return () => {
      document.removeEventListener("click", handleClickOutsideDropdown);
    };
  }, []);

  const handleOpenModal = (item) => {
    setIsModalOpen(true);
    setSelectedId(item._id);
    setUserDeptEdit(item.user_department);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedId("");
    setUserDeptEdit("");
  };

  const handleDelete = () => {
    setIsDeleteModalOpen(true);
  };

  const handleConfirmDelete = async () => {
    try {
      setIsSubmitLoading(true);
      await deleteUserDepartmentMutation.mutateAsync(selectedId);
      setUpdatedDeptList((prevState) =>
        prevState.filter((deptList) => deptList._id !== selectedId)
      );
      toast.success("Department removed successfully", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      global.config.activityLog(
        window.location.href,
        "Department",
        `Department (${selectedId}) removed successfully`
      );
      handleCloseModal();
    } catch (error) {
      global.config.slackMessage(error.toString());
      toast.error("Something went wrong", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      console.log(error.response.data.message); // print server error message
      if (error.response?.data?.status === "deleted") {
        localStorage.removeItem("user");
        dispatch(logout());
        dispatch(reset());
        dispatch(invoiceReset());
        dispatch(headerReset());
        dispatch(appSettingsReset());
        toast.error("This user is deleted!", {
          position: "bottom-right",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        navigate("/");
        return;
      }
    } finally {
      setIsSubmitLoading(false);
    }
    setIsDeleteModalOpen(false);
  };

  const handleCancelDelete = () => {
    setIsDeleteModalOpen(false);
  };

  const handleCreateSubmit = async (event) => {
    event.preventDefault();
    if (userDeptCreate.trim() === "") {
      setDeptCreateError(true);
      userDeptCreateRef.current.focus();
      return;
    }

    const requestData = {
      user_department: userDeptCreate,
    };
    try {
      setIsSubmitLoading(true);
      const data = await createUserDepartmentMutation.mutateAsync(requestData);
      if (data.status === "error") {
        toast.error("Something went wrong", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        global.config.activityLog(
          window.location.href,
          "TaDepartment",
          `Something went wrong while adding Department`
        );
      } else if (data.status === "exists") {
        toast.error("Department already exists", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        global.config.activityLog(
          window.location.href,
          "TaDepartment",
          `Department already exist`
        );
      } else {
        toast.success("User department added successfully", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        global.config.activityLog(
          window.location.href,
          "TaDepartment",
          `Department ${userDeptCreate} added successfully`
        );
        setUserDeptCreate("");
        setDeptCreateError(false);
      }
    } catch (error) {
      console.log(error);
      global.config.slackMessage(error.toString());
      if (error.response?.data?.status === "deleted") {
        localStorage.removeItem("user");
        dispatch(logout());
        dispatch(reset());
        dispatch(invoiceReset());
        dispatch(headerReset());
        dispatch(appSettingsReset());
        toast.error("This user is deleted!", {
          position: "bottom-right",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        navigate("/");
        return;
      }
      toast.error("Something went wrong");
      global.config.activityLog(
        window.location.href,
        "TaDepartment",
        `Something went wrong`
      );
    } finally {
      setIsSubmitLoading(false); // Set isLoading to false after the approval process is complete
    }
  };

  const handleUpdateSubmit = async (e) => {
    e.preventDefault();
    try {
      setIsSubmitLoading(true);
      const response = await updateUserDepartmentMutation.mutateAsync({
        selectedId,
        user_department: userDeptEdit,
      });
      const data = response.data;

      if (data.status === "error") {
        toast.error("Something went wrong", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else if (data.status === "exists") {
        toast.error("Department already exists", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        setUpdatedDeptList((prevState) => {
          const updatedDepartment = prevState.map((item) => {
            if (item._id === selectedId) {
              return { ...item, user_department: userDeptEdit };
            }
            return item;
          });
          return updatedDepartment;
        });
        toast.success("Department updated successfully", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        global.config.activityLog(
          window.location.href,
          "Department",
          `Department ${userDeptEdit} updated successfully`
        );
        handleCloseModal();
      }
    } catch (error) {
      console.log(error.response.data.message); // print server error message
      global.config.slackMessage(error.toString());
      if (error.response?.data?.status === "deleted") {
        localStorage.removeItem("user");
        dispatch(logout());
        dispatch(reset());
        dispatch(invoiceReset());
        dispatch(headerReset());
        dispatch(appSettingsReset());
        toast.error("This user is deleted!", {
          position: "bottom-right",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        navigate("/");
        return;
      }
      alert("Something went wrong");
    } finally {
      setIsSubmitLoading(false);
    }
  };

  return (
    <div>
      <div className="div-outter-for-department">
        <div className="add-department-section top-filter-client-inner">
          <div className="top-filter-client-inner-left">
            <input
              type="text"
              placeholder="Add new department"
              value={userDeptCreate}
              onChange={(e) => {
                setUserDeptCreate(e.target.value);
                if (deptCreateError) setDeptCreateError(false);
              }}
              ref={userDeptCreateRef}
              className={deptCreateError ? "dept-input-error" : ""}
            />

            <button
              className="add-btn-in-department-b1"
              onClick={handleCreateSubmit}
              disabled={isSubmitLoading}
              style={{
                pointerEvents: isSubmitLoading ? "none" : "auto",
                cursor: isSubmitLoading ? "not-allowed" : "pointer",
              }}
            >
              {isSubmitLoading ? (
                <div
                  style={{
                    width: "20px",
                    height: "20px",
                    backgroundColor: "rgba(255, 255, 255, 0.6)",
                    borderRadius: "50%",
                    animation: "pulse 1.5s ease-in-out infinite",
                    flexShrink: 0,
                    margin: 0,
                    padding: 0,
                    display: "block",
                  }}
                />
              ) : (
                <AddIcon
                  aria-hidden="true"
                  style={{
                    width: "20px",
                    height: "20px",
                    margin: 0,
                    padding: 0,
                    display: "block",
                  }}
                />
              )}
            </button>
          </div>
          <div className="top-filter-client-sort">
            <div className="custom-dropdown1">
              <div
                ref={sortDropdownRef}
                className={`custom-dropdown-user-new-outer custom-dropdown-select ${
                  sortDropdownOpen ? "open" : ""
                }`}
              >
                <div
                  className="selected-option custom-dropdown-user-new"
                  onClick={toggleSortDropdown}
                >
                  <div className="center-sort">
                    {selectedSortOption ? selectedSortOption : "Sort By"}
                  </div>
                </div>
                {sortDropdownOpen && (
                  <div className="custom-dropdown-new">
                    <ul className="type-list">
                      <li
                        className={
                          checkedOption === "By name: A - Z" ? "selected" : ""
                        }
                        onClick={() => selectSortOption("By name: A - Z")}
                      >
                        <span
                          className={`checkbox ${
                            checkedOption === "By name: A - Z" ? "checked" : ""
                          }`}
                        ></span>
                        By name: A - Z
                      </li>
                      <li
                        className={
                          checkedOption === "By name: Z - A" ? "selected" : ""
                        }
                        onClick={() => selectSortOption("By name: Z - A")}
                      >
                        <span
                          className={`checkbox ${
                            checkedOption === "By name: Z - A" ? "checked" : ""
                          }`}
                        ></span>
                        By name: Z - A
                      </li>
                      <li
                        className={
                          checkedOption === "Date: old to new" ? "selected" : ""
                        }
                        onClick={() => selectSortOption("Date: old to new")}
                      >
                        <span
                          className={`checkbox ${
                            checkedOption === "Date: old to new"
                              ? "checked"
                              : ""
                          }`}
                        ></span>
                        Date: old to new
                      </li>
                      <li
                        className={
                          checkedOption === "Date: new to old" ? "selected" : ""
                        }
                        onClick={() => selectSortOption("Date: new to old")}
                      >
                        <span
                          className={`checkbox ${
                            checkedOption === "Date: new to old"
                              ? "checked"
                              : ""
                          }`}
                        ></span>
                        Date: new to old
                      </li>
                    </ul>
                  </div>
                )}
              </div>
            </div>
            <div className="top-filter-client-sort-search">
              <div className="top-filter-client-search">
                <div className="search-sec">
                  <div className="search-container">
                    <input
                      type="text"
                      className="search-input"
                      placeholder="Search by department name"
                      onChange={(e) => setFilter(e.target.value)}
                      value={filter}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className={`department-section-listing${
            shouldAnimate ? " dept-animate" : ""
          }`}
        >
          {isLoading == true ? (
            <>
              {[...Array(12)].map((_, index) => (
                <div className="grid-item" key={`skeleton-${index}`}>
                  <div
                    style={{
                      width: "100%",
                      height: "40px",
                      backgroundColor: "#e5e7eb",
                      border: "0.2px solid rgba(106, 121, 136, 0.7)",
                      borderRadius: "10px",
                      paddingLeft: "15px",
                      display: "flex",
                      alignItems: "center",
                      animation: "pulse 1.5s ease-in-out infinite",
                      boxSizing: "border-box",
                    }}
                  />
                </div>
              ))}
            </>
          ) : (
            <>
              {filteredData.map((item) => (
                <div className="grid-item" key={item._id}>
                  <input
                    type="text"
                    className="input-tag"
                    value={item.user_department}
                    readOnly
                  />
                  <button
                    className="edit-button"
                    onClick={() => handleOpenModal(item)}
                  >
                    <EditImgBlue aria-hidden="true" />
                    Edit
                  </button>
                </div>
              ))}
            </>
          )}
        </div>
      </div>
      <div className="modal-invite-main-outter">
        <Modal
          className="client-modal leave"
          isOpen={isModalOpen}
          onRequestClose={isSubmitLoading ? undefined : handleCloseModal}
          contentLabel="New Client Account"
          style={{
            content: {
              height: "41%",
              width: "30%",
              position: "fixed",
              top: "50%",
              left: "50%",
              parent: document.querySelector(".admin-outer.time.tracker"),
            },
          }}
        >
          <div className="modal">
            <div className="modal-close-invite outter-modal-main">
              <a className="" onClick={handleCloseModal}>
                <CrssrImage aria-hidden="true" />{" "}
              </a>
            </div>
            <div className="modal-client-head">
              <h2 className="">Edit Department</h2>
            </div>
            <div className="form-field-client-outer">
              <form onSubmit={handleUpdateSubmit}>
                <div className="form-field-client">
                  <label htmlFor="clientName" className="form-label">
                    Department Name
                  </label>
                  <input
                    type="text"
                    id="clientName"
                    name="clientName"
                    className="form-input"
                    value={userDeptEdit}
                    onChange={(e) => setUserDeptEdit(e.target.value)}
                    required
                  />
                </div>
                {isSubmitLoading ? (
                  <div className="form-field-client-btns">
                    <div
                      style={{
                        minWidth: "120px",
                        height: "44px",
                        backgroundColor: "#e5e7eb",
                        border: "1px solid rgba(106, 121, 136, 0.3)",
                        borderRadius: "6px",
                        animation: "pulse 1.5s ease-in-out infinite",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        boxSizing: "border-box",
                      }}
                    >
                      <div
                        style={{
                          width: "60px",
                          height: "18px",
                          backgroundColor: "rgba(255, 255, 255, 0.6)",
                          borderRadius: "4px",
                          animation: "pulse 1.5s ease-in-out infinite",
                        }}
                      />
                    </div>
                    <div
                      style={{
                        minWidth: "120px",
                        height: "44px",
                        backgroundColor: "#e5e7eb",
                        border: "1px solid rgba(106, 121, 136, 0.3)",
                        borderRadius: "6px",
                        animation: "pulse 1.5s ease-in-out infinite",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        boxSizing: "border-box",
                        marginLeft: "10px",
                      }}
                    >
                      <div
                        style={{
                          width: "100px",
                          height: "18px",
                          backgroundColor: "rgba(255, 255, 255, 0.6)",
                          borderRadius: "4px",
                          animation: "pulse 1.5s ease-in-out infinite",
                        }}
                      />
                    </div>
                  </div>
                ) : (
                  <div className="form-field-client-btns">
                    <button
                      type="button"
                      className="delete-client"
                      onClick={handleDelete}
                      disabled={isSubmitLoading}
                    >
                      <Delete aria-hidden="true" /> Delete
                    </button>
                    <Modal
                      className="delete-modal"
                      isOpen={isDeleteModalOpen}
                      onRequestClose={handleCancelDelete}
                      contentLabel="Confirm Delete"
                      style={{
                        content: {
                          height: "41%",
                          width: "30%",
                          position: "fixed",
                          top: "36%",
                          left: "50%",
                          parent: document.querySelector(
                            ".admin-outer.time.tracker"
                          ),
                        },
                      }}
                    >
                      <div className="delete-modal-content">
                        <h2>Confirm Delete</h2>
                        <p>Are you sure you want to delete this Department?</p>
                        {isSubmitLoading ? (
                          <div className="delete-modal-buttons">
                            <div
                              style={{
                                minWidth: "100px",
                                height: "44px",
                                backgroundColor: "#e5e7eb",
                                border: "1px solid rgba(106, 121, 136, 0.3)",
                                borderRadius: "6px",
                                animation: "pulse 1.5s ease-in-out infinite",
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                                boxSizing: "border-box",
                              }}
                            >
                              <div
                                style={{
                                  width: "60px",
                                  height: "18px",
                                  backgroundColor: "rgba(255, 255, 255, 0.6)",
                                  borderRadius: "4px",
                                  animation: "pulse 1.5s ease-in-out infinite",
                                }}
                              />
                            </div>
                            <div
                              style={{
                                minWidth: "100px",
                                height: "44px",
                                backgroundColor: "#e5e7eb",
                                border: "1px solid rgba(106, 121, 136, 0.3)",
                                borderRadius: "6px",
                                animation: "pulse 1.5s ease-in-out infinite",
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                                boxSizing: "border-box",
                                marginLeft: "10px",
                              }}
                            >
                              <div
                                style={{
                                  width: "60px",
                                  height: "18px",
                                  backgroundColor: "rgba(255, 255, 255, 0.6)",
                                  borderRadius: "4px",
                                  animation: "pulse 1.5s ease-in-out infinite",
                                }}
                              />
                            </div>
                          </div>
                        ) : (
                          <div className="delete-modal-buttons">
                            <button
                              className="delete"
                              onClick={handleConfirmDelete}
                              disabled={isSubmitLoading}
                            >
                              Delete
                            </button>
                            <button onClick={handleCancelDelete}>Cancel</button>
                          </div>
                        )}
                      </div>
                    </Modal>
                    <button
                      type="submit"
                      className="save-changes"
                      disabled={isSubmitLoading}
                    >
                      Save Changes
                    </button>
                  </div>
                )}
              </form>
            </div>
          </div>
        </Modal>
      </div>
      <style>{`
        @keyframes pulse {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.5;
          }
        }
      `}</style>
    </div>
  );
};

export default TimeTrackerTeamDepartment;
